export interface AppSpecs {
  'specs.funnel.StudioTemplatesMegaMenuNewUiV3': 'true' | 'false';
  'specs.funnel.StudioTemplatesUseBCatalog': 'true' | 'false';
}

export const defaultAppSpecValues: AppSpecs = {
  'specs.funnel.StudioTemplatesMegaMenuNewUiV3': 'false',
  'specs.funnel.StudioTemplatesUseBCatalog': 'false',
};
